const en = {
  handle: {
    search: 'Search',
    export: 'Export',
    exportPDF: 'Export as PDF',
    confirm: 'Confirm',
    save: 'Save',
    cancel: 'Cancel',
    add: 'Add',
    confirmAndAdd: 'Continue to add after confirm',
    readd: 'Readd',
    edit: 'Edit',
    reedit: 'Reedit',
    delete: 'Delete',
    detail: 'Detail',
    detail_lower: 'detail',
    submit: 'Submit',
    send: 'Send',
    turnDown: 'turn down',
    back: 'Back',
  },
  week: {
    acedemicWeek: 'Academic Week',
    addWeek: 'Add a week',
    schoolYear: 'School year',
    semester: 'Semester',
    weekName: 'Week name',
    startName: 'Start date',
    endDate: 'End date',
    Operate: 'Operate',
    pleaseFill: 'Please fill',
    confirmDelete: 'Confirm to delete {content} !',
    edit: 'Edit',
  },
  public: {
    colon: ': ',
    switchLanguage: 'Do you want to switch language?',
    page: 'There are {total} of them, {pageSize} per page',
    searchList: 'Search {content}',
    operate: 'Operate',
    pleaseChoose: 'Please choose the {content} !',
    pleaseFill: 'Please fill in the {content} !',
    pleaseUpdate: 'Please update the {content} !',
    add: 'Add {content}',
    change: 'Change {content}',
    delete: 'Delete {content}',
    edit: 'Edit {content}',
    title: 'Title',
    title_lower: 'title',
    name: 'Name',
    name_lower: 'name',
    englishName: 'English name',
    studentNumber: 'Student number',
    address: 'Address',
    address_lower: 'address',
    saveSuccess: 'Successfully saved!',
    confirmDelete: 'Are you sure delete item?',
    deleteSuccess: 'Successfully delete!',
    sendSuccess: 'Sent successfully, to be approved by the reviewer!',
    turnDownSuccessfully: 'Successfully turn down!',
    upload: 'Upload',
    uploadFailed: 'upload failed!',
    uploadSuccess: 'Upload success!',
    uploading: 'Uploading file!',
    status: 'Status',
    status_lower: 'status',
    suspending: 'Suspend',
    dropout: 'Withdraw',
    returnSchool: 'Return',
    graduation: 'Graduation',
    enrollmentRecord: 'Enrollment Record',
    close: 'Close',
    open: 'Open',
    archive: 'Archive',
    active: 'Active',
    remark: 'Remark',
    remark_lower: 'remark',
    grade: 'Grade',
    grade_lower: 'grade',
    student: 'Student',
    student_lower: 'student',
    subject: 'Subject',
    teacher: 'Teacher',
    classroom: 'Classroom',
    class: 'Class',
    class_lower: 'class',
    academicYear: 'Academic year',
    semester: 'Semester',
    exam: 'Term',
    account: 'Account',
    account_lower: 'account',
    timeWeek: 'Time/Week',
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
    saturday: 'Saturday',
    sunday: 'Sunday',
    staff: 'Staff',
    staff_lower: 'staff',
    all: 'All',
    grades: 'Subject Grades',
    grades_lower: 'subject grades',
    score: 'Score',
    score_lower: 'score',
    comments: 'Comments',
    comments_lower: 'comments',
    transcript: 'Report Card',
    officalTranscript: 'Official Transcript',
    averageScore: 'Average Score',
    level: 'Level',
    editor: 'Editor',
    submitTime: 'Submit Time',
    content: 'Content',
    schoolYears: 'School Years',
    headmaster: 'Class Advisor',
    startedYear: 'Started Year',
    department: 'Department',
    department_lower: 'department',
    timetable: 'Timetable',
    permission: 'Permission',
    permission_lower: 'permission',
    updateRecord: 'Update Record',
    emptyUrl: 'The export file Url is empty!',
    successfullyExported: 'Successfully exported!',
    lastName: 'Last name',
    lastName_lower: 'last name',
    firstName: 'First name',
    firstName_lower: 'first name',
    dateOfBirth: 'Date of birth',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    enrollmentGradeTitle: 'Enrollment Grade',
    enrollmentGrade: 'Enrollment grade',
    enrollmentGrade_lower: 'enrollment grade',
    currentGrade: 'Current grade',
    currentGrade_lower: 'current grade',
    enrollmentTime: 'Enrollment time',
    enrollmentTime_lower: 'enrollment time',
    studentId: 'ID',
    checkPending: 'Check pending',
    confirmModification: 'Confirm modification',
    roster: 'Roster',
    selected: 'Selected',
    unselected: 'Unselected',
    attachment: 'Attachment',
    attachment_lower: 'attachment',
    entryIntoForceTime: 'Start Time',
    graduated: 'Graduated',
    suspension: 'Suspension',
    pre10: 'Pre-10',
    10: '10',
    11: '11',
    12: '12',
    classAdvisorFeedback: 'Class Advisor Feedback',
    classAdvisorFeedback_lower: 'class advisor feedback',
    category: 'Category',
    number: 'Number',
    number_lower: 'number',
    record: 'Record',
    campus: 'Learning Center',
    campus_lower: 'learning center',
    operator: 'Operator',
    midterm: 'Midterm',
    final: 'Finals',
    cumulativ: 'Cumulative Score',
    semester1: '1st Semester',
    semester2: '2nd Semester',
    resetPassword: 'Reset Password',
    email: 'E-mail',
    verificationCode: 'Verification Code',

    workingDay: 'Working day',
    time: 'Time',
    position: 'Position',
    mobile: 'Mobile',
    id: 'ID',
    attendanceGroup: 'Attendance group',
    earliest: 'Earliest',
    latest: 'Latest',
    times: 'Times',
    beLate: 'Be late',
    holidayEarly: 'Holiday early',
    complete: 'Complete',
    notClockIn: 'Not clock in',
    duration: 'Duration',
    duration_lower: 'duration',
    usedDuration: 'Used duration',
    remainingDuration: 'Remaining duration',
    hour: 'Hour',
    hour_lower: 'hour',
    location: 'Location',
    members: 'Members',
    distance: 'Distance',
    scheduling: 'Scheduling',
    clockIn: 'Clock in',
    clockOut: 'Clock out',
    type: 'Type',
    dateOfSubmission: 'Date of submission',
    auditor: 'Auditor',
    currentSchool: 'Current School',
    scoreReports: 'score management',
    quitSchool: 'QS',
    dropOut: 'DO',
    ClassAdviser: 'Class Adviser',
    addSuccessTips: 'Added successfully',
    messageCenter: 'Message center',
    approval: 'Approval',
    recordr: 'Recordr',
    approveAll: 'Approve All',
    approve: 'Approve',
    reject: 'Reject',
    scoreType: 'Score Type',
    details: 'Details',
    oldScore: 'Old Score',
    newScore: 'New Score',
    submissionTime: 'Submission Time',
    submitter: 'Submitter',
    result: 'Result',
    approver: 'Approver',
    approvalTime: 'Approval Time',
    attendance: 'Attendance',
    assignment: 'Assignment',
    participation: 'Participation',
    quiz: 'Quiz',
    week: 'Week',
    quizName: 'Quiz Name',
    campusName: 'Campus Name',
    campusSelect: 'Select Campus',
    studentNumberO: 'Student Number',
    chineseName: 'Chinese Name',
    fristName: 'Frist Name',
    lastNameDetail: 'Last Name',
    statisticsStudent: 'Statistics Student',
    statisticsSubject: 'Statistics Subject ',
    exportData: 'Confirm Export data ?',
  },

  user: {
    account: 'Account',
    password: 'Password',
    passwordTip: ' (Initial password: catschina0000)',
    signIn: 'Sign in',
    signOut: 'Sign out',
    signInSuccess: 'Log in successfully!',
    changePassword: 'Change password',
    confirmPassword: 'Password Confirmation',
    newPasswordTip: 'Please enter a new password!',
    confirmPasswordTip: 'Please confirm the password!',
    passwordsInconsistent: 'Two passwords that you enter is inconsistent!',
    changePasswordSuccess: 'Successful password modification!',
    reLogin: 'The landing has expired, please re-login!',
    sendSuccess:
      'The verification code has been sent, please check it in the mailbox!',
  },

  student: {
    manage: 'Student',
    allStudent: 'All student',
    newStudent: 'New student',
    addStudent: 'Add a student',
    majorType: 'Major type',
  },

  campus: {
    manage: 'Learning Center',
    allCampus: 'All Learning Center',
    newCampus: 'New learning Center',
    addCampus: 'Add a learning Center',
    enterCampus: 'Enter the learning Center',
  },

  staff: {
    permission: 'Permission',
    manage: 'Staff',
    allStaff: 'All staff',
    allDepartment: 'All department',
    newStaff: 'New staff',
    addStaff: 'Add a staff',
    staffList: 'Staff list',
    subject: 'Subjects',
    teachers: 'Teachers',
    subjects: 'Subjects',
    addSubject: 'Add new subject',
    delete: 'Delete',
    teacher: 'Teacher',
    inputTipsSub: 'Please input your subject',
    applicableobject: 'Applicable object',
    allStudent: 'All Students',
    relatedStudent: 'Related Students',
    promptSelection: 'Please select {content}',
    addSubjects: 'New subjects',
    type: 'Type',
    campus: 'Campus',
    subjectName: 'Subject Name',
    science: 'Science',
    english: 'English',
    liberalArts: 'Liberal Arts',
    arts: 'Arts',
    music: 'Music',
    drama: 'Drama',
    PE: 'PE',
    club: 'Club',
  },
  statistics: {
    manage: 'Statistics',
    overview: 'Statistics Overview',
    performace: 'Daily Performace',
    weeks: 'Weeks',
    ExportStatistics: 'Export Statistics',
    quiz: 'Quiz',
    MidTermExam: 'Mid-Term Exam',
    FinalTerm: 'Final-Term Exam',
    ComprehensiveResults: 'Comprehensive Results',
  },
  class: {
    messageClass: 'Please select students',
    manage: 'Class',
    allClass: 'All class',
    newClass: 'New class',
    addClass: 'Add a class',
    basic: 'Basic',
    promotion: 'Promotion',
    archive: 'Archive',
    errorTitle: 'Operation failure ',
    messageDesc: 'Please select class',
    success: 'Success',
    exportAll: 'Export Students',
    sureExport: 'Are you sure to export the current student?',
    sureExportTip:
      'All students meeting the current conditions will be exported.',
    classType: 'Class type',
    administrativeClass: 'Administrative Class',
    electiveClass: 'Elective Class',
    addStudentErrorTips: 'Please select the students to add',
  },

  timetable: {
    manage: 'Timetable',
    teacherTimetable: 'Teacher',
    classTimetable: 'Class',
    editTimetable: 'Edit Timetable',
    deleteTimetable: 'Delete Timetable',
    occupied: 'Occupied by {className}',
    resetTimetable: 'Do you want to delete these timetable?',
    needSubject: 'Please choose a subject!',
    needTeacher: 'Please choose a teacher!',
    import: 'Import',
    downLoadTemplate: 'Download template',
  },

  grades: {
    manage: 'Grades',
    regularGrades: 'Term Performance',
    termGrades: 'Term Exam',
    subjects: 'Subjects',
    weeks: 'Teaching week(s)',
    weeks_lower: 'teaching week(s)',
    advisorComment: 'Advisor Comment',
    editWeek: 'Modify teaching week(s)',
    participation: 'Participation',
    participation_lower: 'participation',
    assignments: 'Assignment',
    assignments_lower: 'assignment',
    attendance: 'Attendance',
    attendance_lower: 'attendance',
    quiz: 'Quiz',
    quiz_lower: 'quiz',
    basic: 'Basic',
    midGradeTip:
      'The Mid-Term score of one subject does not represent the final result for that academic year.  The final academic year result of each subject comprises of in-class performance, homework, attendance, quiz, mid-term score and end of semester exam score.',
    waitSave: 'Saving, please wait!',
    emptyGrade: 'There are scores not filled in!',

    submitGradeTip:
      '请确认所有成绩信息填写正确。您只能提交一次。重新编辑需要验证。',
    reeditTip: '重新提交需要验证。会将验证链接发送到教务主管的邮箱进行确认。',
    verificationCode: '验证码',
    verificationCode_lower: '验证码',
    exportReport: '确认导出成绩单？',
    currentStudent: '当前学生',
    currentClass: '当前班级',
    confirmModificationResults: '确认修改成绩',
    currentGrade: '当前成绩',
    modifiedScore: '修改成绩',
    confirmModificationFeedback: '确认修改班主任反馈',
    currentFeedback: '当前反馈',
    modifiedFeedback: '修改反馈',
  },

  report: {
    manage: 'Reports',
    submitGradeTip:
      'Please confirm that all grade information has been filled in correctly. You can only submit once. Reedit needs verification.',
    reeditTip:
      "Resubmission requires validation. The verification link will be sent to the dean's mailbox for confirmation.",
    verificationCode: 'Verification Code',
    verificationCode_lower: 'verification code',
    exportReport: 'Confirm Export Report card?',
    currentStudent: 'Current Student',
    currentClass: 'Current Class',
    confirmModificationResults: 'Confirm Modification Results',
    currentGrade: 'Current grade',
    modifiedScore: 'Modified grade',
    confirmModificationFeedback: 'Confirm Modification Class Advisor Feedback',
    currentFeedback: 'Current Feedback',
    modifiedFeedback: 'Modified Feedback',
    academicYear: 'Academic Year',
    grade: 'Grade',
    report: 'Report',
    status: 'Status',
    finalOperatingTime: 'Final operating time',
    operate: 'Operate',
    reportCard: 'Report Card',
    officialTranscript: 'Official Transcript',
    reportCardTipsOpen: 'Open student transcripts',
    reportCardTipsClose: 'Close student transcripts',
    reportCardName: 'score management',
    exportBasic: 'Confirm export term performance ?',
  },

  scholarship: {
    manage: 'Student Performance',
    scholarship: 'Scholarship',
    reward: 'Scholarship',
    punishment: 'Punishment',
    punishment_lower: 'punishment',
    rewardPunishment: 'Scholarship and Punishment',
    endStudy: 'End of the Study',
    monthStar: 'Star of the Month',
    yellowCard: 'Yellow Card',
    redCard: 'Red Card',
    recommendedReason: 'Recommended Reason',
    medal: 'Medal',
    referrer: 'Referrer',
    homeroomTeacher: 'Homeroom Teacher',
    learningDiscipline: 'Discipline',
    academicRecord: 'Academic record',
    recreationalActivities: 'Recreational activities',
    competitionSelection: 'Competition selection',
    award: 'Award',
    scholarshipRecord: 'Scholarship Record',
    punishmentRecord: 'Punishment Record',
  },
}

export default en
